const apiUrl = 'https://erwatoday.in/';

export default apiUrl;